import React, { useState } from "react";
import PropTypes from "prop-types";
import { Hidden, Stack, Toolbar } from "@mui/material";
import Account from "./Account";
import useAuth from "../../contextapi/hooks/useAuth";
import { Box,AppBar } from "@mui/material";
import { TimerRender } from "../../components";
import { bgBlur } from "../../utils/cssStyles";
import clsx from "clsx";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    background: ({ isKon }) => isKon
      ? 'linear-gradient(70deg, rgba(144,232,234,1) 12%, rgba(0,201,213,1) 42%, rgba(15,93,167,1) 74%, rgba(6,60,153,1) 93%)'
      : 'rgb(5, 30, 52)',
    zIndex: '1029',
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 70,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },
  toolbar: {
    minHeight: 64,
  },
}));



const TopBar = ({ className, onMobileNavOpen, img, ...rest }) => {
  const { user } = useAuth();

  React.useEffect(() => {}, []);
  const isKon = false
  const classes = useStyles({ isKon });

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
      <Hidden xsDown>
          <TimerRender />
        </Hidden>
        <Box ml={2} flexGrow={1} />

        <Box ml={2}>

        
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {},
};

export default TopBar;
